import { createFileRoute } from "@tanstack/react-router";
import { IssuesBoard } from "#app/components/issues/issues-board";

/** `/team/$teamId/board` — the team's Kanban across its workflows (read-only). */
function TeamBoardRoute() {
  const { teamId } = Route.useParams();
  return <IssuesBoard scope={{ kind: "team", teamId }} />;
}

export const Route = createFileRoute("/(app)/$workspace/team/$teamId/board")({
  component: TeamBoardRoute,
});
